import React, { useState, useEffect, useCallback} from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { Box, Container, Grid, CircularProgress, Typography } from "@mui/material";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import "../../css/PaginaProducto/Productos.css"

export const PaginaProductoComponenete = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoriaId = params.get("id");
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [categoria, setcategorias] = useState([]);
  const [categoriaSeleccionado, setcategoriaSeleccionado] = useState(null);
  const [productoAll, setProductoAll] = useState([]);
  const categoriaSeleccionadaData = categoria.find(cat => cat.id === categoriaSeleccionado);




  useEffect(() => {
    if (categoriaId) {
      setcategoriaSeleccionado(Number(categoriaId));
    }
  }, [categoriaId]);

  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const aumentarCantidadProducto = async (id) => {
    try {
      await axios.put(`${backendURL}/api/conteo/visitas/${id}`);
    } catch (error) {
      console.error('Error al aumentar cantidad:', error);
    }
  };

   const fetchSliders = useCallback(async () => {
    setLoading(true)
      try {
        const response = await axios.get(`${backendURL}/api/all/public/producto/home`);
          
         setcategorias(response.data.data);
         setLoading(false)
      } catch (error) {
        console.error("Error al obtener sliders:", error);
      }
    }, [ backendURL]);
  
    // Llamada inicial a sliders cuando hay token
    useEffect(() => {
     
        fetchSliders();
      
    }, [ fetchSliders]);


 const fetchProductos = useCallback(async () => {
      try {
        const response = await axios.get(`${backendURL}/api/all/public/productos`);
          
         setProductoAll(response.data.data);
      } catch (error) {
        console.error("Error al obtener sliders:", error);
      }
    }, [backendURL]);
  
    // Llamada inicial a sliders cuando hay token
    useEffect(() => {
     
        fetchProductos();
      
    }, [ fetchProductos]);



  const productosAgrupados = productoAll.reduce((acc, producto) => {
    const tipo = producto.tipo_producto && producto.tipo_producto.trim() !== ""
      ? producto.tipo_producto
      : "";

    if (!acc[tipo]) acc[tipo] = [];
    acc[tipo].push(producto);
    return acc;
  }, {});

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} />
        </Box>
      </div>
    );
  }
  return (
    <Container maxWidth='lg'>

      <Box sx={{ pt: 15, pb: 1 }}>
        <div className="TituloPorductosHome">
          <h1 className="parte1" >Nuestros </h1>

          <h1 className="parte2"> Productos</h1>
        </div>
      </Box>

      <Box sx={{
        marginBottom: '100px', ' @media (max-width:300px)': {
          marginBottom: '0px'
        },
      }}>
        <Grid container spacing={1} justifyContent="center" ref={ref}>
          {categoria.map((service, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Box
                className={`contienebotonpaginaproducto ${categoriaSeleccionado === service.id ? 'activo' : ''}`}
                onClick={() => setcategoriaSeleccionado(service.id)}
              >
                <Box
                  className="imagenproductopagina"
                  component="img"
                  src={`${backendURL}/${service.imagen_filtro}`} // Puedes reemplazar por tu imagen
                  alt="HOD | Maquinas Dispensadoras"
                  title="HOD | Maquinas Dispensadoras"

                />

                <Box >
                  <h3 className="Titulopaginaproducto">{service.titulo}</h3>
                  <h3 className="Titulopaginaproducto">{service.titulo1}</h3>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>


       {categoriaSeleccionadaData && categoriaSeleccionadaData.descripcion && (
          <Box
            className="detalle-producto"
            sx={{ mt: 4, p: 3, borderRadius: 2 }}
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 1,
              }}
            >
              {categoriaSeleccionadaData.descripcion && (
                <>
                  <h2 className="descripcionpagionaproducto">{categoriaSeleccionadaData.descripcion}</h2>
                  {(categoriaSeleccionadaData.descripcion1 || categoriaSeleccionadaData.descripcion2 || categoriaSeleccionadaData.descripcion3) && (
                    <span style={{
                      color: categoriaSeleccionadaData.color || '#000',
                      fontWeight: 'bold',
                      margin: '0 8px',
                      fontSize: '1.8rem'
                    }}>/</span>
                  )}
                </>
              )}
              {categoriaSeleccionadaData.descripcion1 && (
                <>
                  <h2 className="descripcionpagionaproducto">{categoriaSeleccionadaData.descripcion1}</h2>
                  {(categoriaSeleccionadaData.descripcion2 || categoriaSeleccionadaData.descripcion3) && (
                    <span style={{
                      color: categoriaSeleccionadaData.color || '#000',
                      fontWeight: 'bold',
                      margin: '0 8px',
                      fontSize: '1.8rem'
                    }}>/</span>
                  )}
                </>
              )}
              {categoriaSeleccionadaData.descripcion2 && (
                <>
                  <h2 className="descripcionpagionaproducto">{categoriaSeleccionadaData.descripcion2}</h2>
                  {categoriaSeleccionadaData.descripcion3 && (
                    <span style={{
                      color: categoriaSeleccionadaData.color || '#000',
                      fontWeight: 'bold',
                      margin: '0 8px',
                      fontSize: '1.8rem'
                    }}>/</span>
                  )}
                </>
              )}
              {categoriaSeleccionadaData.descripcion3 && (
                <h2 className="descripcionpagionaproducto">{categoriaSeleccionadaData.descripcion3}</h2>
              )}
            </Box>

            {categoriaSeleccionadaData.texto_informacion && (
              <div className="texto-informacion">
                <p>{categoriaSeleccionadaData.texto_informacion}</p>
              </div>
            )}
          </Box>
        )}
      </Box>

      <Box >
        {Object.entries(productosAgrupados).map(([tipoProducto, productos]) => {
          if (tipoProducto.toLowerCase() === 'telemetría') return null;
          // Filtra productos según la categoría seleccionada (si hay una)
          const productosFiltrados = productos.filter(producto =>
            categoriaSeleccionado ? producto.categoria_id === categoriaSeleccionado : true
          );

          // Si no hay productos en esta categoría, no mostrar nada
          if (productosFiltrados.length === 0) return null;

          const descripcion = (productos[0] && productos[0].descripcion_tipo_producto) 
                    ? productos[0].descripcion_tipo_producto.trim() 
                    : "";
         

          const descripcionValida = descripcion !== "" && descripcion !== "undefined";


          return (
            <Box key={tipoProducto} sx={{ width: '100%', marginBottom: '4rem', }}>
              {/* Mostrar el título solo si hay tipoProducto (no vacío) */}
              {tipoProducto && (
                <Box sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: "flex-start",
                  flexDirection: 'column',
                  '@media (max-width:600px)': {
                    alignItems: 'center',
                    justifyContent: 'center'

                  },

                }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '2rem',
                      textTransform: 'uppercase',
                      marginBottom: '2rem',
                      color: '#1A425B',
                      textAlign: 'center',
                      fontFamily: 'Montserrat',
                      '@media (max-width:600px)': {
                        fontSize: '1.3rem',

                      },

                    }}
                  >
                    {tipoProducto}
                  </Typography>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {descripcionValida && (
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: 'Montserrat',
                          fontSize: '1.3rem',
                          fontWeight: '600',
                          textAlign: 'center',
                          color: '#1A425B',
                          '@media (max-width:600px)': {
                            fontSize: '0.95rem',
                          },
                        }}
                      >
                        {descripcion}
                      </Typography>
                    )}
                  </Box>

                </Box>
              )}

              <Grid container spacing={1}>
                {productosFiltrados.map(producto => {
                 const esCasiaLockers = (producto.tipo_producto || '').toLowerCase() === 'casia lockers';

                  return (
                    <Grid
                      key={producto.id}
                      size={{ xs: 12, sm: esCasiaLockers ? 12 : 6, md: esCasiaLockers ? 12 : 4 }}

                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Link
                        to={`/producto/hod/${producto.id}/${producto.categoria_id}`}
                        onClick={() => aumentarCantidadProducto(producto.id)}
                        style={{ textDecoration: 'none', color: 'inherit', width: '100%' }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            margin: '50px 0px',
                            p: 4,
                            borderRadius: '10px',

                            transition: 'all 0.4s ease',
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: '#F2F2F2',
                              borderRadius: '20px',
                              transform: 'scale(1.02)',
                            },
                          }}
                        >
                          {esCasiaLockers ? (
                            <Box sx={{ width: '90%' }}>
                              <img
                                src={`${backendURL}/${producto.imagen_producto}`}
                                alt="HOD | Maquinas Dispensadoras"
                                title="HOD | Maquinas Dispensadoras"
                                style={{ width: '100%', marginBottom: '1rem' }}
                              />
                            </Box>
                          ) : (
                            <Box className='imagenproducto'>
                              <img
                                src={`${backendURL}/${producto.imagen_producto}`}
                                alt="HOD | Maquinas Dispensadoras"
                                title="HOD | Maquinas Dispensadoras"
                                style={{ width: '100%', marginBottom: '1rem' }}
                              />
                            </Box>
                          )}

                          {!esCasiaLockers && (
                            <>
                              <Typography
                                variant="h3"
                                gutterBottom
                                sx={{
                                  textTransform: 'uppercase',
                                  fontWeight: '400',
                                  fontSize: '1.8rem',
                                  fontFamily: 'Montserrat',
                                  letterSpacing: '1px',
                                  color: '#1A425B',
                                  textAlign: 'center',
                                  margin: '0',
                                  '@media (max-width:600px)': {
                                    fontSize: '1rem',
                                  },
                                }}
                              >
                                {producto.titulo_maquina}
                              </Typography>

                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: '1.5rem',
                                  textTransform: 'uppercase',
                                  fontWeight: '700',
                                  fontFamily: 'Montserrat',
                                  textAlign: 'center',
                                  color: producto.color || '#1A425B',
                                  '@media (max-width:600px)': {
                                    fontSize: '1rem',
                                  },
                                }}
                              >
                                {producto.nombre_maquina}
                              </Typography>
                            </>
                          )}


                        </Box>
                      </Link>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          );
        })}

      </Box>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', flexDirection: 'column',
        margin: '50px 0px'
      }}>
        <h2 className="preguntaproducto">¿Necesitas impulsar tu negocio?</h2>
        <Link to='/contacto' style={{ textDecoration: 'none', color: 'inherit' }}>
          <button className="buttoncotizarproducto"> Cotiza con nosotros</button>
        </Link>
      </Box>
    </Container>
  )
}